import { EmptyUploadEntityIdError } from '../errors';
import type { UploaderState } from './index';

/**
 * Id of the entity the bytes are written into: the file id for a file upload,
 * the proxy id for a proxy one. Both live on the kind that creates them.
 */
export function getUploadEntityId<Meta, ChunkMeta>(
  state: UploaderState<Meta, ChunkMeta>,
): string | undefined {
  const uploadKind = state.uploadKind;
  return uploadKind.kind === 'proxy' ? uploadKind.proxyId : uploadKind.fileId;
}

export function unwrapUploadEntityId<Meta, ChunkMeta>(
  state: UploaderState<Meta, ChunkMeta>,
): string {
  const entityId = getUploadEntityId(state);
  if (!entityId) {
    throw new EmptyUploadEntityIdError('Upload entity ID is not set');
  }
  return entityId;
}

/**
 * State update that records the upload entity for whichever kind is in play.
 * Passing undefined clears it, which is how a restarted upload forgets the
 * entity it can no longer write to.
 */
export function updateUploadEntityId<Meta, ChunkMeta>(
  state: UploaderState<Meta, ChunkMeta>,
  entityId: string | undefined,
): Partial<UploaderState<Meta, ChunkMeta>> {
  const uploadKind = state.uploadKind;
  if (uploadKind.kind === 'proxy') {
    return { uploadKind: { ...uploadKind, proxyId: entityId } };
  }
  return { uploadKind: { ...uploadKind, fileId: entityId } };
}
